import { Copy } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '~/components/ui/button'

type IProps = {
  value: string
  /** Nom accessible du bouton (icône seule) : ce qui est copié. */
  label: string
  copiedMessage: string
  /** Dit quoi faire à la place : le presse-papiers est refusé hors HTTPS ou sans permission. */
  failedMessage: string
}

/** Copie une valeur montrée une seule fois (secret, mot de passe émis), avec un retour toast. */
export function CopyButton({ value, label, copiedMessage, failedMessage }: IProps) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      toast.success(copiedMessage)
    } catch {
      toast.error(failedMessage)
    }
  }

  return (
    <Button type="button" variant="outline" size="sm" onClick={copy} aria-label={label}>
      <Copy className="size-4" />
    </Button>
  )
}
